/**
 * The panel the two method cards open, ON THE PAGE rather than over it.
 *
 * The prototype puts fixed booking in a modal (`poc:#booking-modal`). This does
 * not: the client is choosing a time for an order whose products, address and
 * price are all on the page behind it, and a dialog is exactly the thing that
 * takes those away at the moment they matter. So the panel renders under the
 * cards, everything else stays visible, and only the part that depends on the
 * client's choice changes.
 *
 * It keeps the prototype's chrome for the open state — white on the container's
 * beige, with the accent border — because that is what says "this belongs to the
 * card above it".
 */

import React, { ReactNode } from 'react'
import { Stack } from '@mui/material'

import { SELECTED_BLUE, WHITE } from 'constants/styling/theme'

interface Props {
  /** Optional header row — a title on the left, an action on the right. */
  header?: ReactNode
  children: ReactNode
  dataCy?: string
}

export const SchedulePanel: React.FC<Props> = ({ header, children, dataCy }) => (
  <Stack
    gap={1.2}
    data-cy={dataCy}
    sx={{
      p: 1.6,
      backgroundColor: WHITE,
      borderRadius: '1.2rem',
      border: `1px solid ${SELECTED_BLUE}`,
    }}
  >
    {header}
    {children}
  </Stack>
)
